import React, { useState } from "react";
import { de } from "date-fns/locale";
import { format, parseISO } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { fieldCls } from "@/components/accounting/ui";

export const DatePick = ({ value, onChange, fallbackMonth, testId }) => {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <div className="relative">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testId} className={`${fieldCls} flex items-center gap-2 text-left pr-8`}>
            <CalendarDays size={14} className="text-faint shrink-0" />
            <span className={date ? "text-ink" : "text-faint"}>{date ? format(date, "dd.MM.yyyy") : "Datum wählen"}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-surface border-line" align="start" data-testid={`${testId}-popover`}>
          <Calendar mode="single" locale={de} weekStartsOn={1} selected={date} defaultMonth={date || fallbackMonth} initialFocus
            onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} />
        </PopoverContent>
      </Popover>
      {date && (
        <button type="button" onClick={() => onChange("")} aria-label="Datum entfernen" data-testid={`${testId}-clear`}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-faint hover:text-ink transition-colors"><X size={14} /></button>
      )}
    </div>
  );
};

export default DatePick;
